import { Dispatch } from 'redux'

import notificationTypes from '../../config/notificationTypes'

import ServerErrorInterface from '../../interfaces/server/Error'

import addNotifications from '../../actions/notifications/addNotifications'

import generateUniqueId from '../generateUniqueId'
import isNotificationGlobal from './isNotificationGlobal'

import buildCustomNotification from './buildCustomNotification'

export default (dispatch: Dispatch, errors: any[]) => {
  if (!errors.length) return

  const serverErrors = errors.map((error: ServerErrorInterface) => {
    return buildCustomNotification({
      id: generateUniqueId(),
      type: notificationTypes.warning,
      message: error.message,
      code: error.code,
      isGlobal: isNotificationGlobal(error),
      passengerId: error.data && error.data.passengerId,
      isInfant: error.data && error.data.isInfant === 'true',
      fieldName: error.data && error.data.fieldName,
    })
  })

  dispatch(addNotifications(serverErrors))
}
